// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2NNgL","pipeSpacer":"Footer_pipeSpacer__2-grP","itemSpacer":"Footer_itemSpacer__d3i1D"};